import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 19,
	viewBox: "0 0 14 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 16.5C1.00158 17.0299 1.2128 17.5377 1.58753 17.9125C1.96227 18.2872 2.47005 18.4984 3 18.5H11C11.5299 18.4984 12.0377 18.2872 12.4125 17.9125C12.7872 17.5377 12.9984 17.0299 13 16.5V6.5C12.9984 5.97005 12.7872 5.46227 12.4125 5.08753C12.0377 4.7128 11.5299 4.50158 11 4.5H3C2.47005 4.50158 1.96227 4.7128 1.58753 5.08753C1.2128 5.46227 1.00158 5.97005 1 6.5V16.5ZM13 1.5H10.5L9.79 0.79C9.6032 0.606068 9.35215 0.50206 9.09 0.5H4.91C4.64785 0.50206 4.3968 0.606068 4.21 0.79L3.5 1.5H1C0.734784 1.5 0.48043 1.60536 0.292893 1.79289C0.105357 1.98043 0 2.23478 0 2.5C0 2.76522 0.105357 3.01957 0.292893 3.20711C0.48043 3.39464 0.734784 3.5 1 3.5H13C13.2652 3.5 13.5196 3.39464 13.7071 3.20711C13.8946 3.01957 14 2.76522 14 2.5C14 2.23478 13.8946 1.98043 13.7071 1.79289C13.5196 1.60536 13.2652 1.5 13 1.5Z",
		fill: "#ea3943"
	})
});
export { SvgCloseIcon as ReactComponent };
